<template>
  <section class="invoice-preview-wrapper">
    <b-alert
        variant="danger"
        :show="!isFatura"
    >
      <h4 class="alert-heading">
        {{ errorText }}
      </h4>
    </b-alert>
    <b-row
        class="invoice-preview"
        v-if="isFatura"
    >
      <b-col
          cols="12"
          xl="9"
          md="8"
      >
        <b-card
            no-body
            class="invoice-preview-card"
        >
          <b-card-body class="invoice-padding pb-0">
            <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
              <div>
                <h4 class="card-text mb-25 font-weight-bold text-success cursor-pointer"
                    @click="$router.push({name:'cariDetay',params:{id:fatura.faturaOzeti.cariKartID}})"
                >
                  {{ fatura.faturaOzeti.faturaUnvan }}
                </h4>
                <p class="card-text mb-25 font-weight-bold">
                  {{ fatura.faturaOzeti.adi }} {{ fatura.faturaOzeti.soyAdi }}
                </p>
                <p class="card-text mb-0">
                  Tel: {{ fatura.faturaOzeti.telefon }}
                </p>
                <p class="card-text mb-0">
                  E-Posta: {{ fatura.faturaOzeti.ePosta }}
                </p>
                <p class="card-text mb-0">
                  Vergi Dairesi: {{ fatura.faturaOzeti.vergiDairesi }}
                </p>
                <p class="card-text mb-0">
                  Vergi Numarası: {{ fatura.faturaOzeti.vergiNumarasi }}
                </p>
                <hr/>
                <p class="card-text mb-0">
                  Fatura Notu: {{ fatura.faturaOzeti.faturaNotu }}
                </p>
              </div>
              <div class="mt-md-0 mt-2">
                <h4 class="float-right unPrint">
                  <b-badge :variant="fatura.faturaOzeti.odemeDurum != 1  ?'light-warning':'light-primary'">
                    {{ fatura.faturaOzeti.odemeDurum != 1 ? 'Açık Fatura' : 'Kapalı Fatura' }}
                  </b-badge>
                </h4>
                <h4 class="invoice-title mt-50 unPrint">
                  <b-badge :variant="fatura.faturaOzeti.faturaTuru == 1  ?'light-success':'light-primary'">
                    {{ fatura.faturaOzeti.faturaTuru == 1 ? 'Satış Faturası' : 'Alış Faturası' }}
                  </b-badge>
                </h4>
                <h4 class="invoice-title">
                  KayıtID
                  <span class="invoice-number"> #{{ fatura.faturaOzeti.kayitID }}</span>
                </h4>
                <div class="invoice-date-wrapper d-block">
                  <p class="mb-0 text-right">
                    Tahsilat Tarihi:
                  </p>
                  <p class="invoice-date text-right">
                    {{ fatura.faturaOzeti.tahsilatTarih }}
                  </p>
                </div>
                <div class="invoice-date-wrapper d-block">
                  <p class="mb-0 text-right">
                    Düzenlenme Tarihi:
                  </p>
                  <p class="invoice-date text-right">
                    {{ fatura.faturaOzeti.duzenlenmeTarih }}
                  </p>
                </div>
              </div>
            </div>
          </b-card-body>
          <hr class="invoice-spacing">
          <b-card-body
              v-if="true"
              class="invoice-padding pt-0"
          >
            <!--            <b-row class="invoice-spacing">-->
            <!--              <b-col-->
            <!--                  cols="12"-->
            <!--                  xl="6"-->
            <!--                  class="p-0"-->
            <!--              >-->
            <!--                <h6 class="mb-2">-->
            <!--                  Fatura Bilgileri-->
            <!--                </h6>-->
            <!--                <h6 class="mb-25">-->
            <!--                  selamlar-->
            <!--                </h6>-->
            <!--                <p class="card-text mb-25">-->
            <!--                  selamlar-->
            <!--                </p>-->
            <!--                <p class="card-text mb-25">-->
            <!--                  selamlar selamlar-->
            <!--                </p>-->
            <!--                <p class="card-text mb-25">-->
            <!--                  selamlar-->
            <!--                </p>-->
            <!--                <p class="card-text mb-0">-->
            <!--                  selamlar-->
            <!--                </p>-->
            <!--              </b-col>-->
            <!--              <b-col-->
            <!--                  xl="6"-->
            <!--                  cols="12"-->
            <!--                  class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end"-->
            <!--              >-->
            <!--                <div>-->
            <!--                  <h6 class="mb-2">-->
            <!--                    Ödeme Bilgileri:-->
            <!--                  </h6>-->
            <!--                  <table>-->
            <!--                    <tbody>-->
            <!--                    <tr>-->
            <!--                      <td class="pr-1">-->
            <!--                        Toplam Ödenecek:-->
            <!--                      </td>-->
            <!--                      <td><span class="font-weight-bold" v-if="fatura.faturaBilgileri.toplamTutar">{{-->
            <!--                          fatura.faturaBilgileri.toplamTutar.toFixed(2)-->
            <!--                              .replace(/\d(?=(\d{3})+\.)/g, '$&,')-->
            <!--                        }} TL</span></td>-->
            <!--                    </tr>-->
            <!--                    <tr>-->
            <!--                      <td class="pr-1">-->
            <!--                        Banka:-->
            <!--                      </td>-->
            <!--                      banka gelmiyor-->
            <!--                    </tr>-->
            <!--                    <tr>-->
            <!--                      <td class="pr-1">-->
            <!--                        IBAN:-->
            <!--                      </td>-->
            <!--                      TR:10103105301-->
            <!--                    </tr>-->
            <!--                    </tbody>-->
            <!--                  </table>-->
            <!--                </div>-->
            <!--              </b-col>-->
            <!--            </b-row>-->
          </b-card-body>
          <b-table-lite
              striped
              hover
              id="fatura-detay"
              responsive
              :items="fatura.faturaBilgileri.birimData"
              :fields="fields"
          >
            <template #cell(MalHizmet)="data">
              <b-card-text class="font-weight-bold mb-25">
                {{ data.item.urunAdi }}
              </b-card-text>
              <b-card-text class="text-nowrap">
                {{ data.item.taskDescription }}
              </b-card-text>
            </template>
            <template #cell(birimFiyat)="data">
              <b-card-text class="font-weight-bold mb-25">
                {{
                  Number(data.item.tutar)
                }}
                <font-awesome-icon icon="turkish-lira-sign"/>
              </b-card-text>
            </template>
            <template #cell(toplamTutar)="data">
              <b-card-text class="font-weight-bold mb-25">
                {{
                  Number(data.item.toplamTutar)
                }}
                <font-awesome-icon icon="turkish-lira-sign"/>
              </b-card-text>
            </template>
            <template #cell(0015)="data">
              <b-card-text class="font-weight-bold mb-25">
                {{ gelirOptimize(data.item.vergiData.vergiListesi, '0015') }}%
              </b-card-text>
            </template>
            <template #cell(0040)="data">
              <b-card-text class="font-weight-bold mb-25">
                {{ gelirOptimize(data.item.vergiData.vergiListesi, '0040') }}%
              </b-card-text>
            </template>
            <template #cell(0059)="data">
              <b-card-text class="font-weight-bold mb-25">
                {{ gelirOptimize(data.item.vergiData.vergiListesi, '0059') }}%
              </b-card-text>
            </template>
            <template #cell(4080)="data">
              <b-card-text class="font-weight-bold mb-25">
                {{ gelirOptimize(data.item.vergiData.vergiListesi, '4080') }}%
              </b-card-text>
            </template>
            <template #cell(0021)="data">
              <b-card-text class="font-weight-bold mb-25">
                {{ gelirOptimize(data.item.vergiData.vergiListesi, '0021') }}%
              </b-card-text>
            </template>
            <!--            <template v-slot:[`cell(${vergi.vergiAdi})`]="{ data }" v-for="(vergi,i) in vergiListesi">-->
            <!--              <b-card-text class="font-weight-bold mb-25" :key="i">-->
            <!--                {{ data }} %-->
            <!--              </b-card-text>-->
            <!--            </template>-->
          </b-table-lite>
          <b-card-body class="invoice-padding pb-0">
            <b-row>
              <b-col
                  cols="12"
                  md="6"
                  class="mt-md-0 mt-3"
                  order="2"
                  order-md="1"
              >
                <!--                <b-card-text class="mb-0">-->
                <!--                  <span class="font-weight-bold">Salesperson:</span>-->
                <!--                  <span class="ml-75">Alfie Solomons</span>-->
                <!--                </b-card-text>-->
              </b-col>
              <b-col
                  cols="12"
                  md="6"
                  class="mt-md-6 d-flex justify-content-end"
                  order="1"
                  order-md="2"
              >
                <div class="invoice-total-wrapper">
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">
                      Ara Toplam:
                    </p>
                    <p class="invoice-total-amount" v-if="fatura.faturaBilgileri.araToplam">
                      {{
                        Number(fatura.faturaBilgileri.araToplam)
                      }}
                      <font-awesome-icon icon="turkish-lira-sign"/>
                    </p>
                  </div>
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">
                      Toplam Vergi:
                    </p>
                    <p class="invoice-total-amount" v-if="fatura.faturaBilgileri.toplamVergi">
                      {{
                        Number(fatura.faturaBilgileri.toplamVergi)
                      }}
                      <font-awesome-icon icon="turkish-lira-sign"/>
                    </p>
                  </div>
                  <div class="invoice-total-item" v-for="(vergi ,i) in fatura.faturaBilgileri.vergiData" :key="i">
                    <p class="invoice-total-title">
                      {{ vergi.vergiAdi }} <small>{{ vergi.vergiOrani }}% </small>
                    </p>
                    <p class="invoice-total-amount" v-if="vergi.toplamVergi">
                      {{
                        Number(vergi.toplamVergi)
                      }}
                      <font-awesome-icon icon="turkish-lira-sign"/>
                    </p>
                  </div>
                  <hr class="my-50">
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">
                      Toplam Tutar:
                    </p>
                    <p v-if="fatura.faturaBilgileri.toplamTutar" class="invoice-total-amount">
                      {{
                        Number(fatura.faturaBilgileri.toplamTutar)
                      }}
                      <font-awesome-icon icon="turkish-lira-sign"/>
                    </p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
          <hr class="invoice-spacing">
          <b-card-body class="invoice-padding pt-0 pl-1">
            <span class="font-weight-bold">Fatura Açıklaması: </span>
            <span>{{ fatura.faturaOzeti.aciklama }}</span>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          cols="12"
          md="4"
          xl="3"
          class="invoice-actions"
          ref="faturaIslemleri"
      >
        <b-card>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              block
              v-if="fatura.faturaOzeti.eFatura == 0 && fatura.faturaOzeti.faturaTuru == 1"
              v-b-modal.e-fatura-aktar
              :disabled="isFaturaAktar"
              :style="{backgroundColor:$store.getters.COLORS_GET.bgSuccess+'!important',border:'none'}"
          >
            <b-spinner v-if="isFaturaAktar" small />
            E-Fatura'ya Aktar
          </b-button>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              block
              v-if="fatura.faturaOzeti.eFatura == 1 && fatura.faturaOzeti.faturaTuru == 1"
              @click="eFaturaGet"
              :style="{backgroundColor:$store.getters.COLORS_GET.bgInfo+'!important',border:'none'}"
          >
            Faturayı Görüntüle
          </b-button>
          <b-dropdown
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="mb-1 mt-50"
              text="Fatura İşlemleri"
              variant="primary"
              menu-class="w-100"
              lazy
              block
          >
            <!--            <b-dropdown-item variant="primary" v-b-toggle.sidebar-send-invoice>-->
            <!--              <font-awesome-icon icon="fa-solid fa-paper-plane" class="mr-50"/>-->
            <!--              Faturayı Gönder-->
            <!--            </b-dropdown-item>-->
            <b-dropdown-item variant="primary" @click="printAl">
              <font-awesome-icon icon="fa-solid fa-print" class="mr-50"/>
              Yazdır
            </b-dropdown-item>
            <b-dropdown-item :variant="fatura.faturaOzeti.faturaTuru == 1 ? 'success' : 'primary'"
                             v-b-modal.tahsilat-girisi :disabled="bakiye <= 0"
            >
              <font-awesome-icon icon="fa-solid fa-credit-card" class="mr-50"/>
              {{ fatura.faturaOzeti.faturaTuru == 1 ? 'Tahsilat Girişi' : 'Ödeme Yap' }}
            </b-dropdown-item>
            <b-dropdown-item variant="warning" @click="$router.push({name: 'faturaDuzenle',params: { id }})"
                             :disabled="kasaKayitlari.length > 0"
                             v-b-tooltip.hover.left="kasaKayitlari.length > 0  ? 'Tahsilat kaydı bulunmaktadır' :''"
            >
              <font-awesome-icon icon="fa-solid fa-pen-to-square" class="mr-50"/>
              Düzenle
            </b-dropdown-item>
            <b-dropdown-item variant="danger" @click="faturaSil" :disabled="kasaKayitlari.length > 0"
                             v-b-tooltip.hover.left="kasaKayitlari.length > 0 ? 'Tahsilat kaydı bulunmaktadır' :''"
            >
              <font-awesome-icon icon="fa-solid fa-trash-can" class="mr-50"/>
              Sil
            </b-dropdown-item>
            <b-dropdown-item v-if="fatura.faturaOzeti.ihaleID != '0'" variant="success" @click="goIhale()">
              <font-awesome-icon icon="chevron-left" class="mr-50"/>
              İhaleye Git
            </b-dropdown-item>
          </b-dropdown>
          <hr/>
          <b-row>
            <b-col cols="12" class="d-flex justify-content-between mt-50">
              <h5>Fatura Tutarı :</h5>
              <h5>{{
                  Number(fatura.faturaBilgileri.toplamTutar)
                }}
                <font-awesome-icon icon="turkish-lira-sign"/>
              </h5>
            </b-col>
            <b-col cols="12" class="d-flex justify-content-between mt-50">
              <h5>Tahsil Edilen :</h5>
              <h5>{{ tahsilEdilen }}
                <font-awesome-icon icon="fa-solid fa-turkish-lira-sign"/>
              </h5>
            </b-col>
            <b-col cols="12" class="d-flex justify-content-between mt-50">
              <h5>Bakiye :</h5>
              <h5 class="text-right" v-if="fatura.faturaOzeti.faturaTuru == 1 ">
                {{
                  Number(bakiye)
                }}
                <font-awesome-icon icon="turkish-lira-sign"/>
                <b-badge variant="light-success" class="d-block mt-50">
                  Tahsil Edilecek
                </b-badge>
              </h5>
              <h5 class="text-right" v-else>
                {{
                  Number(bakiye)
                }}
                <font-awesome-icon icon="turkish-lira-sign"/>
                <b-badge variant="light-primary" class="d-block mt-50">
                  Ödenecek
                </b-badge>
              </h5>
            </b-col>
          </b-row>
          <hr/>
          <h4 class="mt-50">Tahsilat Kayıtları</h4>
          <b-table
              :sticky-header="true"
              responsive
              :items="kasaKayitlari"
              :fields="tahFields"
              class="tahsilat-table"
          >
            <template #cell(tutar)="data">
              {{
                Number(data.item.tutar)
              }}
              <font-awesome-icon icon="turkish-lira-sign"/>
            </template>
            <template #cell(kayitTarih)="data">
              {{ data.item.kayitTarih.slice(0, 16) }}
            </template>
            <template #cell(kasaID)="data">
              <p class="m-0 d-inline-block" v-if="data.item.girisTuru == 1">Nakit</p>
              <p class="m-0 d-inline-block" v-else-if="data.item.girisTuru == 2">Kredi Kartı</p>
              <p class="m-0 d-inline-block" v-else>Havale</p>
              <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-danger"
                  class="btn-icon rounded-circle d-inline-block float-right"
                  v-b-tooltip.hover.left="'Tahsilat Kaydını Sil'"
                  sm
                  @click="tahsilatRemove(data.item.kasaID,'faturaIslemleri')"
              >
                <font-awesome-icon icon="fa-solid fa-trash-can"/>
              </b-button>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <invoice-sidebar-send-invoice/>
    <invoice-sidebar-add-payment/>
    <b-modal
        id="tahsilat-girisi"
        title="Fatura Tahsilatı"
        hide-footer
        @hidden="tahsilatReset"
    >
      <b-tabs content-class="pt-1" fill>
        <b-tab
            title="Standart"
        >
          <b-row>
            <b-col cols="12">
              <b-form-group
                  label="Tahsilat Şekli:"
              >
                <model-list-select
                    :list="sTahsilat.tahsilatSekli"
                    v-model="sTahsilat.tahsilat"
                    option-value="key"
                    option-text="title"
                >
                </model-list-select>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                  label="Tutar:"
                  label-for="basicInput"
              >
                <b-form-input
                    autocomplete="off"
                    id="basicInput"
                    v-model="sTahsilat.tutar"
                    :step="priceStep"
                    type="number"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                  label="Fiş No:"
                  label-for="basicInput"
              >
                <b-form-input
                    autocomplete="off"
                    id="basicInput"
                    v-model="sTahsilat.fisNo"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                  label="İşlem Notu:"
                  label-for="basicInput"
              >
                <b-form-textarea
                    id="textarea-default"
                    rows="3"
                    v-model="sTahsilat.islemNotu"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" class="d-flex justify-content-end">
              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="secondary"
                  class="mr-50"
                  @click="tahsilatReset"
              >
                <span class="align-middle">Kapat</span>
              </b-button>
              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="success"
                  @click="faturaTahsilat('standart','faturaIslemleri')"
              >
                <feather-icon
                    icon="SaveIcon"
                    class="mr-50"
                />
                <span class="align-middle">Tahsilat Yap</span>
              </b-button>
            </b-col>
          </b-row>
        </b-tab>
        <!--        <b-tab-->
        <!--          title="Çek İle Tahsilat"-->
        <!--        >-->
        <!--          <b-row>-->
        <!--            <b-col cols="12">-->
        <!--              <b-form-group-->
        <!--                label="Çek Üzerindeki İsim:"-->
        <!--              >-->
        <!--                <b-form-input-->
        <!--                  autocomplete="off"-->
        <!--                  id="basicInput"-->
        <!--                  v-model="cekTahsilat.isim"-->
        <!--                />-->
        <!--              </b-form-group>-->
        <!--            </b-col>-->
        <!--            <b-col cols="12">-->
        <!--              <b-form-group-->
        <!--                label="Seri No:"-->
        <!--              >-->
        <!--                <b-form-input-->
        <!--                  autocomplete="off"-->
        <!--                  id="basicInput"-->
        <!--                  v-model="cekTahsilat.seriNo"-->
        <!--                />-->
        <!--              </b-form-group>-->
        <!--            </b-col>-->
        <!--            <b-col cols="12">-->
        <!--              <b-form-group>-->
        <!--                <h6 class="font-weight-normal">Düzenlenme Tarihi:</h6>-->
        <!--                <flat-pickr-->
        <!--                  v-model="cekTahsilat.duzenlenmeTarihi"-->
        <!--                  class="form-control"-->
        <!--                />-->
        <!--              </b-form-group>-->
        <!--            </b-col>-->
        <!--            <b-col cols="12">-->
        <!--              <b-form-group>-->
        <!--                <h6 class="font-weight-normal">Tahsilat Tarihi:</h6>-->
        <!--                <flat-pickr-->
        <!--                  v-model="cekTahsilat.tahsilatTarihi"-->
        <!--                  class="form-control"-->
        <!--                />-->
        <!--              </b-form-group>-->
        <!--            </b-col>-->
        <!--            <b-col cols="12">-->
        <!--              <b-form-group>-->
        <!--                <h6 class="font-weight-normal">Tutar:</h6>-->
        <!--                <b-form-input-->
        <!--                  autocomplete="off"-->
        <!--                  :step="priceStep"-->
        <!--                  v-model="cekTahsilat.tutar"-->
        <!--                  class="form-control"-->
        <!--                  type="number"-->
        <!--                />-->
        <!--              </b-form-group>-->
        <!--            </b-col>-->
        <!--            <b-col cols="12">-->
        <!--              <b-form-group-->
        <!--                label="İşlem Notu:"-->
        <!--                label-for="basicInput"-->
        <!--              >-->
        <!--                <b-form-textarea-->
        <!--                  id="textarea-default"-->
        <!--                  autocomplete="off"-->
        <!--                  class="form-control"-->
        <!--                  rows="3"-->
        <!--                  v-model="cekTahsilat.islemNotu"-->
        <!--                />-->
        <!--              </b-form-group>-->
        <!--            </b-col>-->
        <!--            <b-col cols="12" class="d-flex justify-content-end">-->
        <!--              <b-button-->
        <!--                v-ripple.400="'rgba(113, 102, 240, 0.15)'"-->
        <!--                variant="secondary"-->
        <!--                class="mr-50"-->
        <!--                @click="tahsilatReset"-->
        <!--              >-->
        <!--                <span class="align-middle">Kapat</span>-->
        <!--              </b-button>-->
        <!--              <b-button-->
        <!--                v-ripple.400="'rgba(113, 102, 240, 0.15)'"-->
        <!--                variant="success"-->
        <!--                @click="faturaTahsilat('cek','faturaIslemleri')"-->
        <!--              >-->
        <!--                <feather-icon-->
        <!--                  icon="SaveIcon"-->
        <!--                  class="mr-50"-->
        <!--                />-->
        <!--                <span class="align-middle">Tahsilat Yap</span>-->
        <!--              </b-button>-->
        <!--            </b-col>-->
        <!--          </b-row>-->
        <!--        </b-tab>-->
      </b-tabs>
    </b-modal>
    <b-modal
        id="e-fatura-aktar"
        ok-title="Aktar"
        cancel-title="Vazgeç"
        modal-class="modal-primary"
        cancel-variant="danger"
        ok-variant="success"
        centered
        title="E-Fatura'ya Aktarım Onayı"
        @ok="eFaturaAktar"
        @hidden="iletilecekMail = ''"
    >
      <b-form-group
          label="Faturanın iletileceği mail adresi"
          label-for="basicInput"
      >
        <b-form-input
            id="basicInput"
            v-model="iletilecekMail"
        />
      </b-form-group>
    </b-modal>
  </section>
</template>

<script>
import { ref, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import {
  BSpinner,
  BModal,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTable,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  VBToggle,
  BBadge,
  BDropdown,
  BDropdownItem,
  VBModal,
  BFormTextarea,
  BFormInput,
  BFormGroup,
  BTab,
  BTabs,
  VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import invoiceStoreModule from './faturaComponents/InvoiceSidebarAddNewCustomer.vue'
import InvoiceSidebarSendInvoice from './faturaComponents/InvoiceSidebarSendInvoice.vue'
import InvoiceSidebarAddPayment from './faturaComponents/InvoiceSidebarAddPayment.vue'
import { $themeConfig } from '@themeConfig'
import 'vue-search-select/dist/VueSearchSelect.css'
import { ModelListSelect } from 'vue-search-select/dist/VueSearchSelect.common'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'

const Turkish = require('flatpickr/dist/l10n/tr.js').default.tr
flatpickr.localize(Turkish)
flatpickr(flatPickr)

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  components: {
    BSpinner,
    BTable,
    ModelListSelect,
    BFormTextarea,
    BFormInput,
    BFormGroup,
    BTab,
    BTabs,
    BModal,
    BDropdown,
    BDropdownItem,
    BBadge,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    InvoiceSidebarAddPayment,
    InvoiceSidebarSendInvoice,
  },
  setup() {
    const { invoiceLogo } = $themeConfig.app
    const paymentDetails = ref({})

    const INVOICE_APP_STORE_MODULE_NAME = 'app-invoice'

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })

    const printInvoice = () => {
      window.print()
    }

    return {
      paymentDetails,
      printInvoice,
      invoiceLogo,
    }
  },
  data() {
    return {
      bakiye: 0,
      isFaturaAktar: false,
      isFatura: true,
      iletilecekMail: '',
      errorText: '',
      id: this.$route.params.id,
      fields: [
        {
          key: 'urunAdi',
          label: 'Mal / HizmetAdı',
          sortable: true,
          thStyle: {
            backgroundColor: store.getters.COLORS_GET.tableTitle || '#088395',
            color: 'white',
            border: 'none',
          },
        },
        {
          key: 'adet',
          label: 'Miktar',
          sortable: true,
          thStyle: {
            backgroundColor: store.getters.COLORS_GET.tableTitle || '#088395',
            color: 'white',
            border: 'none',
          },
        },
        {
          key: 'birim',
          label: 'Birim',
          sortable: true,
          thStyle: {
            backgroundColor: store.getters.COLORS_GET.tableTitle || '#088395',
            color: 'white',
            border: 'none',
          },
        },
        {
          key: 'birimFiyat',
          label: 'B. Fiyat',
          sortable: true,
          thStyle: {
            backgroundColor: store.getters.COLORS_GET.tableTitle || '#088395',
            color: 'white',
            border: 'none',
          },
        },
        {
          key: 'toplamTutar',
          label: 'Toplam Tutar',
          sortable: true,
          thStyle: {
            backgroundColor: store.getters.COLORS_GET.tableTitle || '#088395',
            color: 'white',
            border: 'none',
          },
        },
      ],
      tahFields: [
        {
          key: 'tutar',
          label: 'Tutar',
          sortable: true,
          thStyle: {
            backgroundColor: store.getters.COLORS_GET.tableTitle || '#088395',
            color: 'white',
            border: 'none',
          },
        },
        {
          key: 'kayitTarih',
          label: 'Tarih',
          sortable: true,
          thStyle: {
            backgroundColor: store.getters.COLORS_GET.tableTitle || '#088395',
            color: 'white',
            border: 'none',
          },
        },
        {
          key: 'kasaID',
          label: 'girisTuru',
          sortable: true,
          thStyle: {
            backgroundColor: store.getters.COLORS_GET.tableTitle || '#088395',
            color: 'white',
            border: 'none',
          },
        },
      ],
      sTahsilat: {
        islemNotu: '',
        tutar: '',
        fisNo: '',
        tahsilat: {
          title: 'Nakit',
          key: 1,
        },
        tahsilatSekli: [
          {
            title: 'Nakit',
            key: 1,
          },
          {
            title: 'Kredi Kartı',
            key: 2,
          },
          {
            title: 'Havale',
            key: 3,
          },
        ],
      },
      cekTahsilat: {
        islemNotu: '',
        tutar: '',
        seriNo: '',
        duzenlenmeTarihi: '',
        tahsilatTarihi: '',
        isim: '',
      },
    }
  },
  computed: {
    tahsilEdilen() {
      return this.kasaKayitlari.reduce((sum, item) => sum + Number(item.tutar), 0)
    },
    gelirOptimize(val) {
      return (salut, vergiKodu) => {
        if (salut) {
          const veri = Object.values(salut)
              .find(x => x.vergiKodu === vergiKodu)
          return veri?.vergiOrani || 0
        }
        return 0
      }
    },
    vergiListesi() {
      return store.getters.VERGI_LISTESI_GET
    },
    kasaKayitlari() {
      return Object.values(store.getters.FATURA_DETAY_GET.kasaKayitlari)
    },
    fatura() {
      return store.getters.FATURA_DETAY_GET
    },
  },
  methods: {
    goIhale() {
      const { ihaleID } = this.fatura.faturaOzeti
      if (ihaleID && ihaleID !== '0') {
        router.push({ path: `/ihaleDetay/${ihaleID}` })
      }
    },
    faturaSil() {
      this.$swal({
        title: 'Faturayı Sil',
        text: 'Bu işlem geri alınamaz!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet Sil',
        cancelButtonText: 'Vazgeç',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.value) {
              let id = this.id
              store.dispatch('faturaSil', { id })
                  .then((res, position = 'bottom-right') => {
                    if (res.result.status == 200) {
                      if (this.fatura.faturaOzeti.faturaTuru == 1) {
                        this.$router.push('/satislar')
                      } else {
                        this.$router.push('/alislar')
                      }
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Başarılı!',
                          text: res.result.errMsg,
                          icon: 'ThumbsDownIcon',
                          variant: 'success',
                        },
                      }, { position })
                    } else {
                      const mesaj = store.getters.notificationSettings(res)
                      if (mesaj) {
                        this.$toast({
                          component: ToastificationContent,
                          props: {
                            title: 'Hata!',
                            text: mesaj,
                            icon: 'ThumbsDownIcon',
                            variant: 'danger',
                          },
                        })
                      }
                    }
                  })
            }
          })
    },
    eFaturaAktar() {
      this.isFaturaAktar = true
      store.dispatch('eFaturaAktar', {
        kayitID: this.id,
        musteriEposta: this.iletilecekMail,
      })
          .then((res, position = 'bottom-right') => {
            if (res.result.status == 200) {
              store.dispatch('faturaDetay', { id: this.id })
                  .then(res => {
                    if (res.result.status == 200) {
                      this.bakiye = res.bakiye
                    }
                  })
              const mesaj = store.getters.notificationSettings(res)
              if (mesaj) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Başarılı!',
                    text: mesaj,
                    icon: 'ThumbsDownIcon',
                    variant: 'success',
                  },
                }, { position })
              }
            } else {
              const mesaj = store.getters.notificationSettings(res)
              if (mesaj) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Hata!',
                    text: mesaj,
                    icon: 'ThumbsDownIcon',
                    variant: 'danger',
                  },
                })
              }
            }
          })
          .catch(err => {
            const mesaj = this.$store.getters.notificationSettings(err)
            if (mesaj) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Hata!',
                  text: mesaj,
                  icon: 'ThumbsDownIcon',
                  variant: 'danger',
                },
              })
            }
          }).finally(() => {
        this.isFaturaAktar = false
      })
    },
    eFaturaGet() {
      const fd = new FormData()
      fd.append('crm_token', store.state.userToken)
      fd.append('serviceName', 'fatura')
      fd.append('methodName', 'eFaturaDetay')
      fd.append('faturaID', this.fatura.faturaOzeti.faturaID)
      axios.post(store.state.POST_URL, fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
          .then((res, position = 'bottom-right') => {
            const Y = '<html>'
            const X = res.data
            var Z = X.slice(X.indexOf(Y) + Y.length)
            var myWindow = window.open(
                'about:blank',
                'print_popup',
                'width=1000,height=800',
            )
            myWindow.document.write(Z)
            myWindow.print()
            const mesaj = this.$store.getters.notificationSettings(res.data)
            if (mesaj) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Başarılı',
                  text: JSON.stringify(res.data?.errMsg)
                      .slice(1, -1),
                  icon: 'ThumbsUpIcon',
                  variant: 'success',
                },
              }, { position })
            }
          })
          .catch(err => {
            const mesaj = this.$store.getters.notificationSettings(err.data)
            if (mesaj) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Hata!',
                  text: mesaj,
                  icon: 'ThumbsDownIcon',
                  variant: 'danger',
                },
              })
            }
          })
    },
    printAl() {
      window.print()
    },
    tahsilatRemove(kasaID, ref) {
      this.$refs[ref].showLoading = true
      store.dispatch('faturaTahsilatRemove', {
        kasaID,
        id: this.id,
      })
          .then((res, position = 'bottom-right') => {
            this.$bvModal.hide('tahsilat-girisi')
            this.$refs[ref].showLoading = false
            if (res.result.status == 200) {
              let id = this.id
              store.dispatch('faturaDetay', { id })
                  .then(res => {
                    if (res.result.status == 200) {
                      this.bakiye = res.bakiye
                    }
                  })
              if (res.result.errMsg) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Başarılı!',
                    text: res.result.errMsg,
                    icon: 'ThumbsDownIcon',
                    variant: 'success',
                  },
                }, { position })
              }
            }
          })
          .catch(err => {
            this.$refs[ref].showLoading = false
            const mesaj = store.getters.notificationSettings(err)
            if (mesaj) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Hata!',
                  text: mesaj,
                  icon: 'ThumbsDownIcon',
                  variant: 'danger',
                },
              })
            }
          })
    },
    faturaTahsilat(yontem, ref) {
      this.$refs[ref].showLoading = true
      this.sTahsilat.tutar = this.sTahsilat.tutar.replace(',', '.')
      this.cekTahsilat.tutar = this.cekTahsilat.tutar.replace(',', '.')
      if (yontem == 'standart') {
        store.dispatch('faturaTahsilat', {
          aciklama: this.sTahsilat.islemNotu,
          tutar: this.sTahsilat.tutar,
          fisNo: this.sTahsilat.fisNo,
          girisTuru: this.sTahsilat.tahsilat.key,
          id: this.id,
        })
            .then((res, position = 'bottom-right') => {
              this.$bvModal.hide('tahsilat-girisi')
              this.$refs[ref].showLoading = false
              if (res.result.status == 200) {
                let id = this.id
                store.dispatch('faturaDetay', { id })
                    .then(res => {
                      if (res.result.status == 200) {
                        this.bakiye = res.bakiye
                      }
                    })
                if (res.result.errMsg) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Başarılı!',
                      text: res.result.errMsg,
                      icon: 'ThumbsDownIcon',
                      variant: 'success',
                    },
                  }, { position })
                }
              } else {
                const mesaj = store.getters.notificationSettings(res)
                if (mesaj) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Hata!',
                      text: mesaj,
                      icon: 'ThumbsDownIcon',
                      variant: 'danger',
                    },
                  })
                }
              }
              this.tahsilatReset()
            })
            .catch(err => {
              this.$refs[ref].showLoading = false
              const mesaj = store.getters.notificationSettings(err)
              if (mesaj) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Hata!',
                    text: mesaj,
                    icon: 'ThumbsDownIcon',
                    variant: 'danger',
                  },
                })
              }
            })
      }
      if (yontem == 'cek') {
        this.$refs[ref].showLoading = false
      }
    },
    tahsilatReset() {
      this.cekTahsilat.islemNotu = ''
      this.cekTahsilat.tutar = ''
      this.cekTahsilat.seriNo = ''
      this.cekTahsilat.tahsilatTarihi = ''
      this.cekTahsilat.isim = ''
      this.cekDuzenlenmeDate()
      this.$bvModal.hide('tahsilat-girisi')
      this.sTahsilat.islemNotu = ''
      this.sTahsilat.fisNo = ''
      this.sTahsilat.tutar = ''
      this.sTahsilat.tahsilat = {
        title: 'Nakit',
        key: 1,
      }
    },
    cekDuzenlenmeDate() {
      var today = new Date()
      var dd = String(today.getDate())
          .padStart(2, '0')
      var mm = String(today.getMonth() + 1)
          .padStart(2, '0')
      var yyyy = today.getFullYear()
      this.cekTahsilat.duzenlenmeTarihi = yyyy + '-' + mm + '-' + dd
    },
  },
  created() {
    let id = this.id
    store.dispatch('vergiListesi')
        .then(res => {
          if (this.fatura.faturaBilgileri.vergiData) {
            Object.entries(this.fatura.faturaBilgileri.vergiData)
                .forEach(entry => {
                  const [key, value] = entry
                  const haveVergiKey = key.substring(key.indexOf('-') + 1)
                  const match = Object.values(res)
                      .find(x => x.vergiKodu === haveVergiKey)
                  if (match) {
                    this.fields.push({
                      key: match.vergiKodu,
                      label: match.vergiAdi,
                      sortable: true,
                      tdClass: 'vergiFields',
                    })
                  }
                })
          }
        })
    store.dispatch('faturaDetay', { id })
        .then(res => {
          if (res.result.status != 200) {
            this.isFatura = false
            this.errorText = res.result.errMsg
          } else {
            this.bakiye = res.bakiye
            Object.values(res.faturaBilgileri.birimData)
                .forEach(item => {
                  Object.values(item.vergiData.vergiListesi)
                      .reduce((acc, {
                        vergiAdi,
                        vergiKodu,
                      }) => {
                        this.fields.push({
                          key: vergiKodu,
                          label: vergiAdi,
                          sortable: true,
                          thStyle: {
                            backgroundColor: store.getters.COLORS_GET.tableTitle || '#088395',
                            color: 'white',
                            border: 'none',
                          },
                        })
                        return this.fields
                      }, {})
                })
          }
        })
  },
  beforeDestroy() {
    store.commit('FATURA_DETAY_ACTION', 'remove')
  },
}
</script>
<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.vergiFields {
  display: none !important;
}

</style>
<style lang="scss">

@media print {

  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}

.tahsilat-table .b-table tbody tr:hover td:first-child {
  border-left: none;
}

.table th, .table td {
  padding: 0.42rem 0.7rem !important;
}
</style>
